import { createContext } from 'react';

export const defaultModalTransitionContext = {
  transitioning: false,
};

export const ModalTransitionContext = createContext(
  defaultModalTransitionContext
);

export const {
  Consumer: ModalTransitionContextConsumer,
  Provider: ModalTransitionContextProvider,
} = ModalTransitionContext;
